import { Reducer } from "redux";

import { MasterSyncResponse } from "../models/Api/Master";
import { MasterSyncDispatchTypes } from "../models/DispatchTypes/Master";
import { MasterSyncActionDispatchTypes } from "../constants/Master";

export const initialState: MasterSyncResponse = {
  loading: false,
  response: [],
};

const MasterSyncReducer: Reducer<
  MasterSyncResponse,
  MasterSyncDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterSyncActionDispatchTypes.MASTER_SYNC_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterSyncActionDispatchTypes.MASTER_SYNC_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case MasterSyncActionDispatchTypes.MASTER_SYNC_RESET: {
      return initialState;
    }
  }
  return state;
};

export default MasterSyncReducer;
